import { ServiceSection } from '../models';

export const SERVICE_SECTIONS: ServiceSection[] = [
  {
    title: 'SERVICES.SECTIONS.SEND-MONEY.TITLE',
    text: 'SERVICES.SECTIONS.SEND-MONEY.TEXT',
    services: [
      {
        title: 'SERVICES.SECTIONS.SEND-MONEY.TITLE',
        value: 'send-money-equity',
        icon: 'ic-acc-opening',
        text: 'SERVICES.SECTIONS.SEND-MONEY.TEXT',
      },
      {
        title: 'SERVICES.SWIFT-RTGS-EAPPS-REPPS.TITLE',
        value: 'cus-360',
        icon: 'ic-customer-360',
        text: 'SERVICES.SWIFT-RTGS-EAPPS-REPPS.TEXT',
      },
    ],
  },
  {
    title: 'SERVICES.SECTIONS.PAY-OR-BUY.TITLE',
    text: 'SERVICES.SECTIONS.PAY-OR-BUY.TEXT',
    services: [
      {
        title: 'SERVICES.BUY-AIRTIME.TITLE',
        value: 'buy-airtime',
        icon: 'ic-acc-opening',
        text: 'SERVICES.BUY-AIRTIME.TEXT',
      },
      {
        title: 'SERVICES.PAY-BILL.TITLE',
        value: 'pay-bill',
        icon: 'ic-customer-360',
        text: 'SERVICES.PAY-BILL.TEXT',
      },
      {
        title: 'SERVICES.PAY-LOAN.TITLE',
        value: 'pay-loan',
        icon: 'ic-customer-360',
        text: 'SERVICES.PAY-LOAN.TEXT',
      },
    ],
  },
  {
    title: 'SERVICES.SECTIONS.WITHDRAW.TITLE',
    text: 'SERVICES.SECTIONS.WITHDRAW.TEXT',
    services: [
      {
        title: 'SERVICES.WITHDRAW.TITLE',
        value: 'withdraw',
        icon: 'ic-acc-opening',
        text: 'SERVICES.WITHDRAW.TEXT',
      },
    ],
  },
];
